/**
 * Created by hanyong.zheng on 2018/12/28.
 */
import { getWxConfig, uploadImage } from '@/api/app'
const app = {
  state: {},
  mutations: {},
  actions: {
    GetWxConfig ({ commit }, url) {
      return new Promise((resolve, reject) => {
        getWxConfig(url).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UploadImage ({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadImage(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js